<!-- SQL执行页面 -->
<template>
<div class='contact'>
  <el-form v-show="password!=='admin123'" label-width="100px" @submit.native.prevent>
    <el-form-item label="输入密码" required>
      <el-input type="password" v-model="password"></el-input>
    </el-form-item>
    <p style="color:red;margin-left:7rem;" v-show="password!=='admin123'">密码不正确!</p>
  </el-form>
  <el-row v-if="userInfo.user_id==1&&password=='admin123'" v-loading="loading">
    <h4>执行SQL</h4>
    <el-form label-width="100px" @submit.native.prevent>
      <el-form-item label="执行方式" required>
        <el-radio-group v-model="sql.type">
          <el-radio :label="1">执行语句</el-radio>
          <el-radio :label="2">执行文件</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否查询">
        <el-switch
          v-model="sql.queryType"
          active-color="#13ce66"
          inactive-color="#ff4949"
          :active-value="1"
          :inactive-value="2"
          active-text="是"
          inactive-text="否">
        </el-switch>
      </el-form-item>
      <el-form-item label="输入语句" required v-if="sql.type===1">
        <el-input type="textarea" v-model="sql.sqlTxt" :autosize="{minRows:22}"></el-input>
      </el-form-item>
      <el-form-item label="上传文件" required v-else>
        <el-upload
          ref="upload"
          action="1"
          :file-list="sql.sqlFile"
          :before-upload="beforeUpload"
          :multiple="true"
          :on-change="uploadChange"
          :on-remove="uploadRemove"
          accept=".txt,.sql"
          :auto-upload="false">
          <el-row>
            <el-button size="mini" type="primary">选择txt/sql文件</el-button>
          </el-row>
        </el-upload>  
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="onSubmit">执行</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</div>
</template>

<script>
import {executeSql,executeSqlFile} from '@/api/system/dataSy'
import {mapGetters} from "vuex";
export default {
components: {},
data() {
return {
  password:"",
  loading:false,
  sql:{
    type:1,
    queryType:2,
    sqlTxt:"", //sql文本
    sqlFile:[], //sql文件
  },
};
},
computed: {...mapGetters(["userInfo"]),},
watch: {},
methods: {
  // 上传钩子
  beforeUpload(file){
    console.log(file);
    // this.files=file;
    return false;
  },
  // 改变附件
  uploadChange(file,fileList){
    let existFile=fileList.slice(0,fileList.length-1).find(f=>f.name===file.name)
    if(existFile){
      this.$message.error("当前文件已存在!");
      fileList.pop();
    }
    this.sql.sqlFile=fileList;
  },
  // 删除附加
  uploadRemove(file,fileList){
    this.sql.sqlFile=fileList;
  },
  onSubmit(){
    this.$prompt('请输入密码', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal:false,
    }).then(({ value }) => {
      if(value==="admin123"){
        if(this.sql.type===1){ // 语句
          this.loading=true;
          executeSql(this.$qs.stringify({sql:this.sql.sqlTxt,queryType:this.sql.queryType})).then(res=>{
            this.loading=false;
            this.$message.success("执行成功!");
          },err=>{
            this.loading=false;
          })
        }else{
          if(this.sql.sqlFile.length===0){
            this.$message.error("必须上传一个文件!");
            return;
          }
          let fileData=new FormData();
          console.log(this.sql.sqlFile[0]);
          fileData.append("sql",this.sql.sqlFile[0].raw);
          fileData.append("queryType",this.sql.queryType);
          this.loading=true;
          executeSqlFile(fileData).then(res=>{
            this.loading=false;
            this.$message.success("执行成功!");
          },err=>{
            this.loading=false;
          })
        }
      }else{
        this.$message.error("密码错误!");
      }
    }).catch(() => {});
  }
},
created() {},
mounted() {},
activated() {},
}
</script>
<style lang='scss' scoped>
.contact{
  padding: 2vw;
  background: #000;
  width: 96vw;
  height: 100%;
}
/deep/ .el-form-item {
  margin-bottom: 0px;
}
/deep/ .el-textarea__inner,/deep/.el-input__inner {
  background: #000;
  color: #fff;
}
</style>